import React from "react";
import MirsTable from "components/general/table/Table";
import {luckyLoserColumns } from "./Columns";
import { isSpeedSeeding, isSpeedQualification, isSemis } from "components/sports/clb/helper/ClbHelpers";
import { isLiveStatus, isStartListStatus, isFinishedStatus } from "helpers/status";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import Label from "components/general/Label";
import CaptionTable from "components/general/table/CaptionTable";
import Status from "components/presentation/Status";

const LuckyLooser = ({data, extraData, extraData2, mirs_competition, mirs_language, mirs_rsc, breakPoint}) => {
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
 
    const caption = '';
    
    const getColumns = () => {
      return luckyLoserColumns();    
    }

    const getInitialSortBy = () => {
      return  [{ id: 'Result', desc: false }];
    }

    const getHiddenColumns = () => {
      return [];
    }

    const getCurrentIndicator = (row) => {
      return ''  
    }

    const getCellCurrentIndicator = (cellInfo) => {
      return ''  
    }

    return <>
            <MirsTable
                id={`mirs-table-result-lucky-loser${mirs_rsc}`}
                sortable={!isMobile}
                caption={caption}
                data={data}
                columns={getColumns()}
                keyRow={"participant-code"}
                initialSortBy={getInitialSortBy()}
                hiddenColumns={getHiddenColumns()}
                getRowProps={row => { return getCurrentIndicator(row) }}
                getCellProps={cellInfo => {return getCellCurrentIndicator(cellInfo) }}
            />

    </>
}

export default LuckyLooser;

